export default __webpack_public_path__ + "fonts/inter-latin-100-normal.504dccd2137f5ca92319.woff2";